import { css, styled } from 'styled-components';

export const Root = styled.div<{ inline?: boolean }>`
  ${(p) => p.inline && css`
    display: inline-grid !important;
  `}
`;
